import { useContext } from 'react';
import { AuthContext } from './AuthContext.jsx';

export const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true';

// When bypass is on, we short-circuit to a stub so pages/hook consumers
// don't crash if they render before/without a provider. AppAuthProvider
// publishes this same value so direct AuthContext consumers agree with us.
export const BYPASS_VALUE = {
  user: { sub: 'bypass', email: 'dev@example.com', name: 'Dev Bypass' },
  isAuthenticated: true,
  isLoading: false,
  getToken: async () => null,
  login: () => {},
  logout: () => {},
  provider: 'bypass',
};

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (BYPASS_AUTH) return BYPASS_VALUE;
  if (!ctx) {
    throw new Error('useAuth() must be used inside <AppAuthProvider>');
  }
  return ctx;
}
